import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialTwitterIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M19.8796 7.21379C20.6428 6.77629 21.226 6.08329 21.5032 5.25904C20.7868 5.66329 19.9984 5.95904 19.156 6.11654C18.4522 5.40079 17.4784 4.99654 16.4614 5.00002C14.422 5.00002 12.7696 6.58379 12.7696 8.53503C12.7696 8.81153 12.802 9.08103 12.865 9.34003C9.9076 9.20353 7.1446 7.86304 5.2546 5.64754C4.927 6.18479 4.7524 6.79904 4.7542 7.42379C4.7542 8.64878 5.4076 9.73378 6.3976 10.3655C5.8108 10.348 5.2384 10.1958 4.7236 9.92278V9.96653C4.7344 11.6605 5.9746 13.1113 7.6864 13.4315C7.141 13.5715 6.5722 13.5925 6.0178 13.491C6.5128 14.94 7.897 15.9253 9.4666 15.9463C8.1526 16.9315 6.5398 17.4618 4.8802 17.4583C4.5832 17.4583 4.2898 17.4425 4 17.4093C5.692 18.4523 7.6558 19.0035 9.6592 19C16.4524 19 20.1658 13.6135 20.1658 8.94103L20.1532 8.48253C20.8768 7.98904 21.5032 7.36954 22 6.65729C21.3376 6.93729 20.6266 7.12979 19.8796 7.21379Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
